// extracted by mini-css-extract-plugin
export default {"error":"styles_error__m2oHZ","errorContainer":"styles_errorContainer__8IagX","code":"styles_code__sTewL","border":"styles_border__eSGp9"};